import React from 'react';
import _ from 'lodash';

import Table from 'components/Table';
import {DetailTenantInfo} from 'components/TenantInfo';
import Paginator from 'components/Paginator';
import Button from 'components/Button';

import './styles.css';

interface MemberProps {
  id: number;
  email: string;
  fullName: string;
  initials: string;
  avatarCropped: string | null;
  internalAvatarCropped: string | null;
  currentRooms: string;
  upcomingRooms: string;
}

interface PaginationProps {
  elementsCount: number;
  offset: number;
  pageSize: number;
  pageSizes: number[];
}

interface MembersTableProps {
  members: Array<MemberProps>;
  pagination: PaginationProps;
  onPageChange: (
    {offset, pageSize}: {offset: number; pageSize: number}
  ) => void;
  exportMembersCsv: () => void;
  exportingMembersCsv: boolean;
  disableExport: boolean;
  openMembersProfilePage: (memberId: number) => void;
}

const MemberRow = ({openMembersProfilePage, member}) => {
  let currentRooms = [];
  if (member.currentRooms !== '') {
    currentRooms = member.currentRooms
      .split(', ')
      .map(roomNumber => `Current ${roomNumber}`);
  }

  let upcomingRooms = [];
  if (member.upcomingRooms !== '') {
    upcomingRooms = member.upcomingRooms
      .split(', ')
      .map(roomNumber => `Upcoming ${roomNumber}`);
  }
  const roomsText = [...currentRooms, ...upcomingRooms].join(', ');

  return (
    <Table.Row onClick={() => openMembersProfilePage(member.id)}>
      <Table.Cell className="name">
        {member && <DetailTenantInfo tenant={member} />}
      </Table.Cell>
      <Table.Cell className="rooms">{roomsText}</Table.Cell>
    </Table.Row>
  );
};

const MembersTable = ({
  members,
  pagination,
  onPageChange,
  exportMembersCsv,
  exportingMembersCsv,
  disableExport,
  openMembersProfilePage
}: MembersTableProps) => (
  <div className="MembersTable">
    <div className="MembersTable__header">
      <Table>
        <Table.Header>
          <Table.HeaderItem className="name" heading="Member" />
          <Table.HeaderItem className="rooms" heading="Rooms" />
        </Table.Header>
      </Table>
    </div>
    <div className="MembersTable__body">
      <Table>
        <Table.Body>
          {members.map(member => (
            <MemberRow
              key={member.id}
              member={member}
              openMembersProfilePage={openMembersProfilePage}
            />
          ))}
        </Table.Body>
      </Table>
    </div>
    <Paginator
      pagination={pagination}
      onPageChange={onPageChange}
      ActionsComponent={() => (
        <Actions
          exportMembersCsv={exportMembersCsv}
          exportingMembersCsv={exportingMembersCsv}
          disableExport={disableExport}
        />
      )}
    />
  </div>
);

const Actions = ({exportMembersCsv, exportingMembersCsv, disableExport}) => (
  <div className="colab-sidepadding-1">
    <Button
      white
      className="colab-sidepadding-1"
      onClick={exportMembersCsv}
      disabled={disableExport || exportingMembersCsv}>
      Export Members
    </Button>
  </div>
);

export default MembersTable;
